<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>权限管理</el-breadcrumb-item>
      <el-breadcrumb-item>角色设置</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->

      <collapse @getDataList="search">
        <collapse-item>
          <span>名称</span>
          <el-input placeholder="角色名称" v-model="queryInfoparams.params.roleName" clearable
          @change="search"
            @clear="queryInfoparams.params.roleName==null"
            ></el-input>
        </collapse-item>
        <collapse-item>
          <span>编码</span>
          <el-input placeholder="编码" v-model="queryInfoparams.params.roleCode" clearable
          @change="search"
            @clear="queryInfoparams.params.roleCode==null"
            ></el-input>
        </collapse-item>
      </collapse>

      <el-row type="flex" justify="end">
        <el-col class="searchBtns" :span="6">
          <el-button-group>
            <el-button
              v-hasPermission="['role:save']"
              plain
              size="small"
              icon="el-icon-plus"
              @click="showAddDialog"
            >新增角色</el-button>
            <el-button
              v-hasPermission="['role:export']"
              plain
              size="small"
              icon="el-icon-download"
              @click="exportExcel"
            >导出excel</el-button>
            <el-button
              plain
              size="small"
              icon="el-icon-delete"
              @click="deletes"
              v-hasPermission="['role:delete']"
            >删除</el-button>
          </el-button-group>
        </el-col>
      </el-row>

      <!-- 列表区域 -->
      <el-table
        :data="dataList"
        border
        stripe
        @selection-change="handleSelectionChange"
        @sort-change="sortChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" label="No."></el-table-column>
        <el-table-column label="角色名称" sortable="custom" prop="roleName"></el-table-column>
        <el-table-column label="编码" sortable="custom" prop="roleCode"></el-table-column>
        <el-table-column label="类型" sortable="custom" prop="roleTypeName"></el-table-column>
         <el-table-column label="备注" sortable="custom" prop="remark"></el-table-column>
        <el-table-column label="允许删除" prop="isCanDelete">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isCanDelete === '0'" type="success">是</el-tag>
            <el-tag v-else-if="scope.row.isCanDelete === '1'" type="info">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 'Y'" type="success">生效</el-tag>
            <el-tag v-else-if="scope.row.status === 'N'" type="info">失效</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <el-link icon="el-icon-edit" @click="showEditDialog(scope.row.id)">编辑</el-link>
            <el-divider direction="vertical"></el-divider>
            <el-link icon="el-icon-s-custom" @click="setUsers(scope.row)">设置用户</el-link>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfoparams.current"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="queryInfoparams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>

    <!-- 添加角色的对话框 -->
    <el-dialog :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed" slot="title">
      <template slot="title">
        <div>
          <h3>新增角色</h3>
          <el-divider style="font-weight:bold;"></el-divider>
        </div>
      </template>
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="70px">
        <el-form-item label="角色名称" prop="roleName" label-width="100px">
          <el-input v-model="addForm.roleName"></el-input>
        </el-form-item>
        <el-form-item label="角色编码" prop="roleCode" label-width="100px">
          <el-input v-model="addForm.roleCode"></el-input>
        </el-form-item>
        <el-form-item label="首页地址" prop="indexUrl" label-width="100px">
          <el-input v-model="addForm.indexUrl"></el-input>
        </el-form-item>
        <el-form-item label="角色类型" prop="roleType" label-width="100px">
          <el-radio-group v-model="addForm.roleType">
            <el-radio-button label="SYSTEM">内置角色</el-radio-button>
            <el-radio-button label="AGENT">代理商角色</el-radio-button>
            <el-radio-button label="PIPEE">水工公司</el-radio-button>
            <el-radio-button label="ENGINNER">水工</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="状态" prop="status" label-width="100px">
          <el-radio-group v-model="addForm.status">
            <el-radio label="Y">生效</el-radio>
            <el-radio label="N">失效</el-radio>
          </el-radio-group>
        </el-form-item>
         <el-form-item label="备注" label-width="100px">
          <el-input v-model="addForm.remark"></el-input>
        </el-form-item>
        <el-form-item label="选择菜单">
          <el-tree
            :check-strictly="false"
            :data="treeData"
            :show-checkbox="true"
            node-key="id"
            :props="defaultProps"
            ref="checkedIdTree"
          ></el-tree>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveAdd">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改对话框  此处可优化合并为一个对话框-->
    <el-dialog :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed" slot="title">
      <template slot="title">
        <div>
          <h3>编辑角色</h3>
          <el-divider style="font-weight:bold;"></el-divider>
        </div>
      </template>
      <el-form :model="addForm" :rules="addFormRules" ref="editFormRef" label-width="70px">
        <el-form-item label="角色名称" prop="roleName" label-width="100px">
          <el-input v-model="addForm.roleName"></el-input>
        </el-form-item>
        <el-form-item label="角色编码" label-width="100px">
          <el-input v-model="addForm.roleCode" @blur="checkRoleCodeExist"></el-input>
        </el-form-item>
        <el-form-item label="首页地址" prop="indexUrl" label-width="100px">
          <el-input v-model="addForm.indexUrl"></el-input>
        </el-form-item>
        <el-form-item label="角色类型" prop="roleType" label-width="100px">
          <el-radio-group v-model="addForm.roleType">
            <el-radio-button label="SYSTEM">内置角色</el-radio-button>
            <el-radio-button label="AGENT">代理商角色</el-radio-button>
            <el-radio-button label="PIPEE">水工公司</el-radio-button>
            <el-radio-button label="ENGINNER">水工</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="状态" prop="status" label-width="100px">
          <el-radio-group v-model="addForm.status">
            <el-radio label="Y">生效</el-radio>
            <el-radio label="N">失效</el-radio>
          </el-radio-group>
        </el-form-item>
         <el-form-item label="备注" label-width="100px">
          <el-input v-model="addForm.remark"></el-input>
        </el-form-item>
        <el-form-item label="选择菜单">
          <el-tree
            :check-strictly="false"
            :data="treeData"
            :show-checkbox="true"
            node-key="id"
            :props="defaultProps"
            ref="checkedIdTree"
            :default-checked-keys="menuSelectedIdList"
          ></el-tree>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveUpdate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Collapse from '@/components/collapse/Collapse.vue'
import CollapseItem from '@/components/collapse/CollapseItem.vue'
export default {
  components: {
    Collapse,
    CollapseItem,
  },
  data() {
    return {
      // 获取列表的参数对象
      queryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
      },
      // 列表
      dataList: [],
      total: 0,
      // 控制添加 对话框的显示与隐藏
      addDialogVisible: false,
      // 添加和修改用户的表单数据
      addForm: {
        status: 'Y',
      },

      // 添加表单的验证规则对象
      addFormRules: {
        roleName: [
          { required: true, message: '角色名称不能为空', trigger: 'blur' },
        ],
        roleCode: [
          { required: true, message: '角色编码不能为空', trigger: 'blur' },
          {
            min: 2,
            max: 100,
            message: '角色编码长度在2 到 100 个字符之间',
            trigger: 'blur',
          },
          { validate: 'checkRoleCodeExist', trigger: 'blur' },
        ],
        roleType: [
          { required: true, message: '角色类型不能为空', trigger: 'blur' },
        ],
      },
      // 控制修改对话框的显示与隐藏
      editDialogVisible: false,

      // 查询到的信息
      editForm: {},

      // 控制分配角色对话框的显示与隐藏
      setUsersDialogVisible: false,

      // 已选中的角色的id值
      selectedRoleId: '',

      //checkbox选择的只
      multipleSelection: [],
      // 菜单树
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      //编辑页面,已选择的菜单IDS
      menuSelectedIdList: [],

      //角色用户列表对话框标题
      roleNametitle: '',
    }
  },
  methods: {
    //获取菜单树
    getTreeData() {
      //获取按钮,目录,菜单
      var arr = [0, 1, 2]
      this.$get(`permission/getMenuTree?menuType=${arr.join(',')}`).then(
        ({ data: res }) => {
          this.treeData = res.data
        }
      )
    },
    //导出excel
    exportExcel() {
      console.log('-----------')
      let res = this.$export('role/exportExcel', this.queryInfoparams, 'role')
    },
    // 校验角色编码是否已存在
    checkRoleCodeExist() {
      if (this.addForm.roleCode == '') return

      this.$get(`role/check/${this.addForm.roleCode}`).then(({ data: res }) => {
        console.log(res)
        if (res.data === false) {
          this.$message.error('该编码已存在')
          setTimeout(() => {
            this.addForm.roleCode = ''
          }, 1000)
          return false
        } else {
          return true
        }
      })
    },
    // 添加用户的时候判断 账户是否存在
    checkUserExist() {
      if (this.addForm.loginAccount == '') return
      let res = checkUserExist(this.addForm.loginAccount)
      if (res.data === false) {
        this.$message.error('该账户已存在')
        setTimeout(() => {
          this.addForm.loginAccount = ''
        }, 1000)
      }
    },
    //监听字段排序
    sortChange(r) {
      //设置排序字段名
      this.queryInfoparams.sortField = r.prop
      //设置排序字段名
      this.queryInfoparams.sortOrder = r.order

      this.search()
    },
    search(){
        this.queryInfoparams.current=0
         this.getDataList()
    },
    // 获取 查询用户数据列表
    getDataList() {
      // 分页查询用户
      this.$post('role/pageQuery', this.queryInfoparams).then(
        ({ data: res }) => {
          this.dataList = res.records
          this.total = res.total
        }
      )
    },
    // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getDataList()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getDataList()
    },
    // 监听添加用户对话框的关闭事件
    addDialogClosed() {
      this.addForm = {}
      this.menuSelectedIdList = []
      this.$refs.addFormRef.resetFields()
    },
    // 点击按钮 新增角色保存
    saveAdd() {
      console.log(this.$refs.checkedIdTree.getCheckedKeys())

      this.$refs.addFormRef.validate(async (valid) => {
        //获取选择的菜单ID
        var menuIds = this.$refs.checkedIdTree.getCheckedKeys()
        if (menuIds != null) {
          console.log(menuIds.join(','))
          this.addForm.menuIds = menuIds.join(',')
        }

        if (!valid) return
        this.$post('role/save', this.addForm).then(({ data: res }) => {
          if (res.ok) {
            // 隐藏添加的对话框
            this.addDialogVisible = false
            // 刷新列表数据
            this.search()
            this.addDialogClosed()

            return this.$message.success('添加成功')
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    },

    // 展示新增的对话框
    showAddDialog(id) {
      this.addForm.status = 'Y'
      this.addDialogVisible = true
      this.getTreeData()
    },

    // 展示编辑用户的对话框
    showEditDialog(id) {
      this.editDialogVisible = true

      this.$get(`role/get/${id}`).then(({ data: res }) => {
        console.log(res)
        this.addForm = res.data
      })
      this.getTreeData()

      this.$get(`role/getRoleMenu/${id}`).then(({ data: res }) => {
        this.menuSelectedIdList = res.data
      })
    },

    // 监听修改用户对话框的关闭事件
    editDialogClosed() {
      this.addForm = {}
      this.menuSelectedIdList = []
      this.$refs.editFormRef.resetFields()
    },
    // 修改用户信息并提交
    saveUpdate() {
      this.$refs.editFormRef.validate(async (valid) => {
        //获取选择的菜单ID
        var menuIds = this.$refs.checkedIdTree.getCheckedKeys()
        if (menuIds != null) {
          console.log(menuIds.join(','))
          this.addForm.menuIds = menuIds.join(',')
        }

        if (!valid) return
        this.$post('role/save', this.addForm).then(({ data: res }) => {
          if (res.ok) {
            // 隐藏添加的对话框
            this.editDialogVisible = false
            // 刷新列表数据
            this.search()
            this.editDialogClosed()
            return this.$message.success('修改成功')
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    },
    //监控checkbox的选择,为entity的所有值
    handleSelectionChange(val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
    },
    // 批量删除
    async deletes() {
      if (
        this.multipleSelection == null ||
        this.multipleSelection.length <= 0
      ) {
        return this.$message.error('请先勾选要删除的数据')
      }

      var ids = []
      this.multipleSelection.forEach((row) => {
        ids.push(row.id)
      })

      console.log(ids)

      const confirmResult = await this.$confirm(
        '此操作将永久删除, 是否继续?',
        '删除角色',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      ).then(() => {
         this.$delete(`role/batchDelete`, { idList: ids }).then(
            ({ data: res }) => {
              if (!res.ok) {
                return this.$message.error(res.msg)
              }
              this.$message.success(res.msg)

              this.search()
            }
          )
        }).catch(() =>{
          
        })

    
    },
    // 展示分配用户的对话框
    setUsers(record) {
      var roleId = record.id
      this.$router.push({
        path: '/role/roleUser',
        query: {
          roleId: roleId,
          roleName: record.roleName,
          roleType: record.roleType,
        },
      })
    },
  },
  mounted() {
    this.search()
  },
}
</script>

<style lang="less" scoped>
.el-select {
  width: 100%;
}

/deep/.el-collapse-item__content {
  display: flex;
  justify-content: space-between;
}

.searchBtns {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

/deep/.el-collapse-item__wrap {
  border: none !important;
}
/deep/.el-collapse-item__header {
  border: none !important;
}

.el-row {
  flex: 1;
}
</style>